<template>
  <v-form>
    <v-row dense>
      <!-- 3颜色集、4文本输入、5下拉选择、6滑动条、7单选、9开关、10整数、11小数、12单选颜色 -->
      <template v-for="(item,index) in visibleItems">
        <v-col v-show="allVisible || index<max" :key="index" :cols="item.width||12">
          <template v-if="item.type==3">
            <color-select :label="item.name" :items="colors[item.code]" v-model="formData[item.code]" @change="onValueChanged($event,item)"></color-select>
          </template>
          <template v-else-if="item.type==4">
            <v-text-field :label="item.name" v-model="formData[item.code]" :placeholder="item.placeholder" @change="onValueChanged($event,item)" dense hide-details outlined></v-text-field>
          </template>
          <template v-else-if="item.type==5">
            <v-select :label="item.name" :items="coder[item.clsCode]" v-model="formData[item.code]" :placeholder="item.placeholder" item-text="name" item-value="code" :clearable="!item.required" @change="onValueChanged($event,item)" dense hide-details outlined></v-select>
          </template>
          <template v-else-if="item.type==6">
            <v-slider :min="item.valueRange ? parseInt(item.valueRange.split(',')[0]) : 5" :max="item.valueRange ? parseInt(item.valueRange.split(',')[1]) : 100" v-model="formData[item.code]" :label="item.name" @change="onValueChanged($event,item)" hide-details thumb-label dense></v-slider>
          </template>
          <template v-else-if="item.type==7">
            <v-radio-group v-model="formData[item.code]" :label="item.name" @change="onValueChanged($event,item)" dense row hide-details>
              <v-radio v-for="(item,index) in coder[item.clsCode]" :key="index" :label="item.name" :value="item.code"></v-radio>
            </v-radio-group>
          </template>
          <template v-else-if="item.type==9">
            <v-switch v-model="formData[item.code]" @change="onValueChanged($event,item)" dense hide-details inset class="mt-0">
              <template v-slot:prepend>
                <div style="white-space:nowrap;color:#00000099;" class="v-label mr-2">{{item.name}}</div>
              </template>
            </v-switch>
          </template>
          <template v-else-if="item.type==10">
            <int-editor v-model="formData[item.code]" :label="item.name" :placeholder="item.placeholder" @change="onValueChanged($event,item)" dense hide-details outlined></int-editor>
          </template>
          <template v-else-if="item.type==11">
            <decimal-editor v-model="formData[item.code]" :label="item.name" :placeholder="item.placeholder" @change="onValueChanged($event,item)" dense hide-details outlined></decimal-editor>
          </template>
          <template v-else-if="item.type==12">
            <color-editor v-model="formData[item.code]" :label="item.name" :placeholder="item.placeholder" @change="onValueChanged($event,item)" dense hide-details outlined></color-editor>
          </template>
        </v-col>
      </template>

      <v-col v-if="visibleItems.length>max && !allVisible" cols="12" class="text-center mt-2">
        <a @click="onShowMore">显示更多</a>
      </v-col>
      <v-col v-if="visibleItems.length>max && allVisible" cols="12" class="text-center mt-2">
        <a @click="onShowLess"> 收 起 </a>
      </v-col>

    </v-row>
  </v-form>
</template>
<script>
/* eslint-disable no-console */
import { getColors } from '@/plugins/api';
import ColorSelect from './Editor/ColorSelect.vue';
export default {
  props: ['items', 'coder'],
  data () {
    return {
      formData: {},
      colors: {},
      colorGroupEditorVisible: false,
      max: 6,
      allVisible: false,
    }
  },
  created () { this.init() },
  // watch: { wid () { this.init() } },
  computed: {
    visibleItems () {
      return !this.items ? [] : this.items.filter(item => item.visible != false)
    }
  },
  methods: {
    async init () {
      for (let i = 0; i < this.visibleItems.length; i++) {
        let item = this.visibleItems[i];
        if (item.type == 3) await getColors(item.colorGroupCode).then(res => this.$set(this.colors, item.code, res.data))
      }
    },
    setFormData (formData) {
      this.formData = { ...formData };
    },
    setCoder (code, items, clsCode = code) {
      let item = this.items.find(item => item.code == code);
      if (!item) return;
      item.clsCode = clsCode;
      this.coder[clsCode] = items;
    },
    setItemValue (values) { for (let key in values) this.$set(this.formData, key, values[key]) },
    onValueChanged (e, item) {
      if (item.changed) {
        new Function('ξ', 'value', item.changed)(this, e);
      }
      this.$emit('change', e, item);
      if (item.type == 3 && this.colorGroupEditorVisible) this.colorGroupEditorVisible = false;
    },
    onShowMore () {
      this.allVisible = true;
    },
    onShowLess () {
      this.allVisible = false;
    },

    // ======================= 扩展函数,提供给changed事件调用
    show (codes, visible) {
      let codeArr = codes.split(',');
      codeArr.forEach(code => {
        let item = this.items.find(item => item.code == code);
        if (item) this.$set(item, 'visible', visible == null ? true : visible);
      })
    },
    hide (codes) {
      this.show(codes, false);
    },
  },
  components: { ColorSelect }
}
</script>